import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { customerFocusSalesHistorySelectProductType } from '../../../actions';

const ProductTypeFilter = ({placeholder}) => {
    const dispatch = useDispatch()
    const { authUser } = useSelector(({auth}) => auth);
    const { productTypeSalesHistorySelected } = useSelector(({customerFocus}) => customerFocus)
    const [productTypeData, setProductTypeData] = useState([]);
    const [selected, setSelected] = useState(productTypeSalesHistorySelected);
    
    const handleChange = (selected) => {
        setSelected(selected)
        dispatch(customerFocusSalesHistorySelectProductType(selected))
    }

    useEffect(() => {
        let params = {
          company: authUser.company !== "#" ? authUser.company : "",
          salesmanCode: authUser.salesman !== "#" ? authUser.salesman : "",
          username: authUser.username,
          language: 1
        }
    
        const url = `${process.env.REACT_APP_API_URL}customer/findProductType?company=${params.company}&language=${params.language}`;
        axios.get(url, {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}}).then(res => {
            setProductTypeData(res.data)
        })
      },[authUser, productTypeSalesHistorySelected])

    // const customStyles = {
    //     control: (base, state) => ({
    //       ...base,
    //       width: '150px',
    //       'min-width': '150px'
    //     }),
    // };

    const customStyles = {
        menu: (provided, state) => ({
            ...provided,
            zIndex: 9999
        }),
    }
    
    return(
        <Select
            styles={customStyles}
            value={selected}
            onChange={handleChange}
            options={productTypeData}
            placeholder={placeholder}
            isMulti={true}
            isClearable={true}
            />
    );
}

export default ProductTypeFilter;